import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["previewBtn"]

  initialize () { 
    let _this = this;

    if (_this.hasPreviewBtnTarget ) { 
      if (_this.previewBtnTarget.selected) {
        _this.enablePreview(); 
      }
      
      _this.previewBtnTarget.addEventListener('change', function() {
        if (_this.previewBtnTarget.selected) {
          _this.enablePreview(); 
        } else {
          _this.disablePreview(); 
        }
      });

    }

  }

  enablePreview() {
    document.querySelectorAll(".preview-hidden").forEach(function (el) {
      el.classList.add('hidden-important');
    });

    document.querySelector("#fields").classList.remove("constructor_fields");
    document.querySelector("#fields").classList.add("preview");
    document.querySelector("#new_field_btn").classList.add("hidden");

    document.querySelector(".card.form").classList.remove("max-w936");
    document.querySelector(".card.form").classList.add("max-w800");
  }

  disablePreview() {
    document.querySelectorAll(".preview-hidden").forEach(function (el) {
      el.classList.remove('hidden-important');
    });

    document.querySelector("#fields").classList.add("constructor_fields");
    document.querySelector("#fields").classList.remove("preview");
    document.querySelector("#new_field_btn").classList.remove("hidden");


    document.querySelector(".card.form").classList.remove("max-w800");
    document.querySelector(".card.form").classList.add("max-w936");
  }

}